/* eslint-disable react-hooks/set-state-in-effect */
import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useTenant } from '../../contexts/TenantContext'
import {
  loadBugReportPublicConfigSafe,
  shouldShowBugReportHeaderButton,
  subscribeBugReportPublicConfig,
} from './bugReportPublicConfig'

export function useBugReportEnabled() {
  const { currentUser } = useAuth()
  const { currentTenant } = useTenant()
  const [enabled, setEnabled] = useState(false)
  // Tenant admins pick the drafting model; without one the mic is hidden rather
  // than left to fail at the point the user has already spoken.
  const [voiceDraftingEnabled, setVoiceDraftingEnabled] = useState(false)
  const [loading, setLoading] = useState(true)

  const loadConfig = useCallback(async () => {
    if (!currentUser) {
      setEnabled(false)
      setVoiceDraftingEnabled(false)
      setLoading(false)
      return
    }
    try {
      const cfg = await loadBugReportPublicConfigSafe()
      setEnabled(cfg ? shouldShowBugReportHeaderButton(cfg) : false)
      setVoiceDraftingEnabled(cfg?.voice_drafting_enabled === true)
    } catch {
      setEnabled(false)
      setVoiceDraftingEnabled(false)
    } finally {
      setLoading(false)
    }
  }, [currentUser, currentTenant?.id])

  useEffect(() => {
    void loadConfig()
  }, [loadConfig])

  useEffect(() => {
    return subscribeBugReportPublicConfig(() => {
      void loadConfig()
    })
  }, [loadConfig])

  return { enabled, voiceDraftingEnabled, loading }
}
